import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import { otherMenuItems } from 'utils/menuItems';
const Menus = () => {
  const navigate = useNavigate();
  const handleMenu = (ev) => {
    navigate(ev.key);
  };
  return (
    <Menu
      theme='dark'
      mode='inline'
      items={otherMenuItems}
      onClick={handleMenu}
    />
  );
};
export default Menus;
